@if (isProxyServer === false) {
  <ziro-top-nav></ziro-top-nav>
}

@if (isProxyServer === false) {
  <div class="ziro-content">
    <ziro-side-navigation
      [title]="navProps().isHostedEnabled ? 'tkey;admin.microsoft.menu.title' : 'tkey;admin.menu.title'"
      [navSections]="adminLinks()"
      [navProps]="navProps()"
    ></ziro-side-navigation>
    <div class="container-fluid overflow-hidden px-0">
      <router-outlet></router-outlet>
    </div>
  </div>
}

@if (isProxyServer) {
  <ziro-base-container
    [links]="proxyServerLinks"
    [isProxyServer]="isProxyServer"
    [isProxyKeyConfigured]="navProps().isZpcProxyKeyConfigured"
  ></ziro-base-container>
}
